import React from 'react';
import { DragOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Card, Drawer, Tooltip, Typography } from 'antd';

import { Component } from '@totem/components/customDashboard/home/lib/types';
import { sortStringAscending } from '@totem/utilities/tableUtilities';

const { Text } = Typography;

type Props = {
  visible: boolean;
  onClose: () => void;
  componentPallet: Component[];
  onAddComponent: (comp: Component) => void;
  onDragStart: (comp: Component) => void;
  onDragEnd: () => void;
};

const WidgetPaletteDrawer = ({
  visible,
  onClose,
  componentPallet,
  onAddComponent,
  onDragStart,
  onDragEnd,
}: Props) => {
  const sorted = Array.isArray(componentPallet)
    ? [...componentPallet].sort((compA, compB) =>
        sortStringAscending(compA.title, compB.title),
      )
    : [];

  return (
    <Drawer
      title="Widget Palette"
      placement="right"
      onClose={onClose}
      open={visible}
      width={300}
      mask={false}
    >
      <div style={{ marginBottom: '12px' }}>
        <Text type="secondary" style={{ fontSize: '12px' }}>
          Click <strong>+</strong> to add, or drag a widget onto the dashboard.
        </Text>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {sorted.map((comp) => (
          <div
            key={comp.componentId}
            draggable
            {...({
              unselectable: 'on',
            } as React.HTMLAttributes<HTMLDivElement>)}
            style={{ cursor: 'grab', userSelect: 'none' }}
            onDragStart={(evt) => {
              evt.dataTransfer.setData('text/plain', '');

              onDragStart(comp);
            }}
            onDragEnd={onDragEnd}
          >
            <Card
              size="small"
              styles={{ body: { padding: '8px 12px' } }}
              style={{ userSelect: 'none' }}
              title={
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '13px',
                    fontWeight: 500,
                  }}
                >
                  <DragOutlined style={{ opacity: 0.4, flexShrink: 0 }} />
                  <span
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                    title={comp.title}
                  >
                    {comp.title}
                  </span>
                </div>
              }
              extra={
                <Tooltip title="Add to dashboard">
                  <Button
                    type="text"
                    size="small"
                    icon={<PlusOutlined />}
                    onClick={(evt) => {
                      evt.stopPropagation();

                      onAddComponent(comp);
                    }}
                  />
                </Tooltip>
              }
            />
          </div>
        ))}
      </div>
    </Drawer>
  );
};

export default WidgetPaletteDrawer;
